/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
//import { saveAs } from 'file-saver';
import { Link } from '@mui/material';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';



import AskDialog from '../../../components/common/dialog/AskDialog';
import * as fileApi from '../../../lib/api/file';
import SalesQuoteFileList from '../../../components/chancemng/estimate/SalesQuoteFileList'
import { listSalesQuoteFiles } from '../../../modules/chanceModule/salesQuoteFiles';

// 2026-10-23 (250423 피드백 #12): 매입견적서 모듈/컴포넌트를 그대로 복붙해서 쓰던 걸
// 분리 — 자체 redux 모듈(salesQuoteFiles)·컴포넌트(SalesQuoteFileList)를 쓰고,
// fileAttrVal2="매출견적서"로 필터링해 매입견적서 파일과 섞이지 않게 한다.
const SalesQuoteFileListContainer = ({estimate}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const {  files, error, loading } = useSelector(
    ({ chanceModule, loading }) => ({
      files: chanceModule.salesQuoteFiles.files,
      error: chanceModule.salesQuoteFiles.error,
      loading: loading['chance/LIST_SALES_QUOTE_FILES'],
    }),
  );

  useEffect(() => {
    //console.log(estimate,'estiimate');
    if (estimate) {
      dispatch(listSalesQuoteFiles('project', estimate.prjUuid, estimate.qteUuid, '매출견적서'));
    }

  }, [dispatch, estimate]);

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleCellFocusOut = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode(id, 'edit');
  };

  const handleSaveClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.commitRowChange(id);
    apiRef.current.startRowEditMode(id, 'view');

    const row = apiRef.current.getRow(id);

    //edit api call
    onSave(row);
  };

  const onSave = async (data) => {
    //console.log('data', data);
    try {
      const response = await fileApi.editFile(data.id, data);

      if (response.data.result === 'success') {
        apiRef.current.updateRows([{ ...data, isNew: false }]);
        enqueueSnackbar('수정 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      apiRef.current.updateRows([{ id: data.id, _action: 'delete' }]);
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleCancelClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode(id, 'view');

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: 'delete' }]);
    }
  };

  const [removeId, setRemoveId] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const onRemove = async () => {
    try {
      const res = await fileApi.removeFile(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        filterable: false,
      },
      {
        field: 'fileUuid',
        headerName: '파일코드',
        hide: true,
        type: 'string',
        editable: false,
        filterable: false,
      },
      {
        field: 'fileTyp',
        headerName: '파일타입',
        hide: true,
        type: 'string',
        editable: false,
        filterable: false,
      },
      {
        field: 'fileAttrVal1',
        headerName: '프로젝트ID',
        hide: true,
        type: 'string',
        editable: false,
        filterable: false,
      },
      {
        field: 'fileAttrVal2',
        headerName: '파일 타입',
        type: 'string',
        minWidth: 120,
        flex: 0.6,
        editable: false,
        filterable: false,
      },
      {
        field: 'fileAttrVal3',
        headerName: '파일참고2',
        hide: true,
        type: 'string',
        editable: false,
        filterable: false,
      },
      {
        field: 'fileNm',
        headerName: '파일명',
        minWidth: 400,
        flex: 1,
        editable: false,
        filterable: false,
        renderCell: (params) => (
          <Link
            href={params.row.fileUrl}
            rel="noopener noreferrer"
            download
            target="_blank"
          >
            {params.value}
          </Link>
        ),
      },
      {
        field: 'fileDesc',
        headerName: '비고',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
      },

      {
        field: 'crtNm',
        headerName: '등록자',
        minWidth: 80,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'crtDt',
        headerName: '등록일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = apiRef.current.getRowMode(id) === 'edit';

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                onClick={handleSaveClick(id)}
                color="primary"
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleEditClick, handleSaveClick, handleCancelClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };


  return (
    <>
      <SalesQuoteFileList
        apiRef={apiRef}
        columns={columns}
        files={files}
        error={error}
        loading={loading}
        handleRowEditStart={handleRowEditStart}
        handleRowEditStop={handleRowEditStop}
        handleCellFocusOut={handleCellFocusOut}

        columnVisibilityModel={{
          id: false,
          fileUuid: false,
          fileAttrVal1: false,
          fileTyp: false,
        }}      />
      <AskDialog
        visible={visible}
        title="매출견적서  삭제"
        description="선택한 매출견적서 파일을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  )
}

export default SalesQuoteFileListContainer